import Seo from "@/components/Seo";
import { useSite } from "@/context/SiteContext";

export default function Accessibility() {
  const { config } = useSite();
  return (
    <>
      <Seo
        title="Accessibility | Solar Black Belt"
        description="Our commitment to an accessible website: keyboard access, reduced motion, text fallbacks for 3D scenes, and how to send feedback."
      />
      <section className="page-hero">
        <div className="wrap">
          <span className="eyebrow">ACCESSIBILITY</span>
          <h1>Everyone should be able to explore their roof.</h1>
        </div>
      </section>
      <section style={{ paddingBottom: 30 }}>
        <div className="wrap prose" data-testid="accessibility-content">
          <h2>Our commitment</h2>
          <p>
            We aim to keep this site perceivable, operable and understandable for as many people as possible. Accessibility here is a
            practice, not a certification claim — when something does not work for you, we want to hear it.
          </p>

          <h2>What is built in</h2>
          <ul>
            <li>Keyboard operation: every form, dialog and control is reachable by keyboard, with visible focus outlines.</li>
            <li>Motion control: the 3D scenes include an explicit pause control, and the site fully honors your system "reduce motion" setting.</li>
            <li>Non-visual fallbacks: if 3D (WebGL) cannot start, a text fallback appears and every form remains usable.</li>
            <li>Live regions: upload status, lookup results and form feedback are announced politely to screen readers.</li>
            <li>Contrast and type: the palette and type sizes are chosen for readable contrast on a calm paper background.</li>
          </ul>

          <h2>Known limitations</h2>
          <p>
            The interactive 3D concepts are visual illustrations; the same information is available as text captions and metrics. Where
            live map imagery appears in future releases, we will maintain attribution and keyboard-operable controls for its features.
          </p>

          <h2>Feedback</h2>
          <p>
            If you hit a barrier anywhere on this site, call {config.phone} and describe the page and what did not work. We treat
            accessibility feedback as a priority fix, not a ticket number.
          </p>
        </div>
      </section>
    </>
  );
}
